import * as ResendTicketsForm from './components/ResendTicketsForm.css';

export default {
	ResendTicketsForm
};
